module.exports = __webpack_public_path__ + "img/52.97d09b34.jpg";